
  import {Component, Vue, Watch} from 'vue-property-decorator';
  import {Action, Getter} from 'vuex-class';

  import { Booking } from '@/bookings/interfaces';
  import {mdiSvg, nameRoutes} from '../../core/tools';

  @Component({components: {}})
  export default class BaseBooking extends Vue {

    @Getter('hasBookingConfig', {namespace: 'booking'}) hasBookingConfig!: boolean;

    @Getter('bookingList', {namespace: 'booking'}) bookingList!: Booking[];

    @Getter('minDate', {namespace: 'booking'}) minDate!: Booking[];

    @Getter('email', {namespace : 'user'}) email !: string ;

    @Getter('accessToken', {namespace : 'user'}) accessToken !: string ;

    @Getter('maxDate', {namespace: 'booking'}) maxDate!: Booking[];

    @Getter('enableBooking', {namespace: 'site'}) enableBooking!: boolean;

    @Getter('enableMultipleBooking', {namespace: 'site'}) enableMultipleBooking!: boolean;

    @Action('getBookingList', {namespace: 'booking'}) getBookingList !: (string: string) => void;

    @Action('getBooking', {namespace: 'booking'}) getBooking !: (id: string) =>void;


    svgIcons = mdiSvg;

    routes = nameRoutes

    @Watch('$store.state.user.accessToken')
    bookingListAtLogin(){
        if (this.accessToken) this.getBookingList(this.email)
    }
    
    sortDate (dateA:string, dateB:string): number {
    return parseInt(dateA.slice(0, 10).split('-').join(''),10) - parseInt(dateB.slice(0, 10).split('-').join(''), 10);
  }

  }
